import React, { useEffect, useMemo, useState } from 'react'
import { Container, Stack, Heading, Text, OrderedList, ListItem, Box, Button, Spinner, InputGroup, Input, InputLeftAddon, InputRightElement, useClipboard } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { ref, onValue } from 'firebase/database';
import { httpsCallable } from 'firebase/functions';

import FormField from '../../components/FormField';
import Dependent from '../../components/FormField/Dependent';
import { WAITING_LIST_AB_TEXT, WAITING_LIST_SRC } from '../../constants/storage';
import useFunctions from '../../hooks/useFunctions';
import useDatabase from '../../hooks/useDatabase';
import usePortalyLink from '../../hooks/usePortalyLink';
import Link from '../../components/Link'
import sanitize from '../../helpers/sanitize'
import { responsive } from '../../contexts/responsive';

const platformPrefix = {
  'Instagram': {
    label: 'instagram.com/',
    value: 'https://www.instagram.com/'
  },
  'Twitter': {
    label: 'twitter.com/',
    value: 'https://twitter.com/'
  },
  'Tiktok': {
    label: 'tiktok.com/@',
    value: 'https://www.tiktok.com/@'
  },
}

const fields = [
  // {
  //   name: 'name',
  //   label: '怎麼稱呼你呢？',
  //   helper: '本名、社群常用名稱皆可',
  //   rules: {
  //     required: '本題必填喔',
  //   },
  // },
  {
    name: 'email',
    type: 'email',
    label: '請問你的 E-mail 是？',
    helper: '請確認 E-mail 正確，這會是你的註冊帳號。',
    rules: {
      required: '本題必填喔',
    }
  },
  {
    name: 'platform',
    label: '請選擇你主要經營的社群：',
    type: 'select',
    options: [
      'Instagram',
      'Facebook',
      'Twitter',
      'Tiktok',
      '小紅書',
      'medium',
      'Plurk',
      'Podcast',
    ],
    rules: {
      required: '本題必填喔',
    },
    placeholder: '--請選擇--'
  },
  {
    name: 'website',
    label: '你的社群帳號為： (選填，正確填寫排序順位會提高唷！)',
    placeholder: '請輸入完整網址',
    // rules: {
    //   required: '本題必填喔',
    // },
  },
  {
    type: 'checkbox',
    name: 'features',
    label: '你對傳送門的哪些功能感興趣？',
    // helper: '若選項無你的答案，請選擇「其他」並盡可能詳述',
    options: [
      '版面好看',
      '能導流到自己的其他社群',
      '快速建立自己的首頁 / 官網',
      '介紹自己的經歷、作品、收藏',
    ],
    rules: {
      required: '本題必填喔',
    },
  },
  // {
  //   type: 'checkbox',
  //   name: 'type',
  //   label: '你是哪種類型的內容創作者？',
  //   helper: '若性質有重複可複選，若無適當類別可自由填寫',
  //   options: [
  //     '圖文插畫',
  //     'Youtuber',
  //     'PODCAST',
  //     '專業講師',
  //     '偶像網紅',
  //     '迷因梗圖',
  //     '專業作者 (影評、樂評、食記皆屬此類 )',
  //     '電玩實況主',
  //     '設計與美術',
  //     '政治',
  //     '財經投資',
  //     '新聞觀點',
  //   ],
  //   rules: {
  //     required: '本題必填喔',
  //   },
  // },

  // {
  //   type: 'checkbox',
  //   name: 'platforms',
  //   label: '你最用心經營的社群為哪個？',
  //   helper: '最多選 3 個',

  //   rules: {
  //     required: '本題必填喔',
  //     maxLength: 3,
  //   },
  // },
  {
    type: 'radio',
    name: 'exp',
    label: '你過去曾用過類似傳送門的工具嗎？',
    options: [
      '有',
      '無',
    ],
    rules: {
      required: '本題必填喔',
    }
  },
  {
    name: 'expName',
    label: '請提供工具名稱',
    when: ['exp', '有'],
    rules: {
      required: '本題必填喔',
    }
  },
  {
    name: 'feedback',
    label: '其他想詢問或建議的事項 ( 選填 )',
    type: 'textarea',
  },
]

const Em = props => <Text as="span" color="red.400" fontWeight="bold" {...props} />

const tiers = [300, 500, 700]

const addUp = 223

const chtNum = ['一', '二', '三', '四']

const Intro = ({ name, slug, email }) => {
  const database = useDatabase()
  const [waitingListCount, setCount] = useState()
  useEffect(() => {
    if (database) {
      onValue(ref(database, 'waitingListCount'), snapshot => {
        const count = snapshot.val()
        setCount(count)
      }, { onlyOnce: true })
    }
  }, [database])
  const tierIndex = useMemo(() => {
    const diff = waitingListCount - (500 - addUp)
    if (diff >= 0) {
      return tiers.findIndex(tier => diff < tier)
    }
    return -1
  }, [waitingListCount])
  const lastTier = (tiers[tierIndex - 1] ?? 0) + 500
  const total = (tiers[tierIndex] ?? 0) + 500
  return (
    <>
      {name && (
        <Text>
          <Link color="red.400" href={`/${slug}`}>{name}</Link> 的官網是採用【Portaly™ 傳送門】工具架設，這是 2022 全新推出的服務，永久免費使用。
        </Text>
      )}
      {email && (
        <Text>
          這是來自 <Em>{email}</Em> 的邀請。
        </Text>
      )}

      <Text>
        只要 30 秒，你就可以開啟一個專屬的微型社群網站！
      </Text>
      <Text>
        第{chtNum[tierIndex]}波 {lastTier} 組名單已全數發送完畢！第{chtNum[tierIndex + 1]}波<Em>加開 {total - lastTier || '---'} 組</Em> (目前<Em>剩餘 {waitingListCount ? (total - addUp - waitingListCount) : '---'} 組</Em>) VIP 帳號索取中！
      </Text>
      <Text>*五月起，依填寫順序搶先使用❤️</Text>
      <Text>傳送門精選案例：
        <Link
          href={`https://portaly.cc/portaly?utm_source=waiting-list&utm_medium=link&utm_campaign=${slug}`}
          isExternal
          color="red.400"
          textDecoration="underline"
        >https://portaly.cc/portaly</Link>
      </Text>
      <Box height="1" bg="custom.primary" />
    </>
  )
}

const WaitingListForm = ({ profileId = '', invitationEmail, profileName, profileSlug }) => {
  const functions = useFunctions()
  // const [captchaLoaded, setCaptchaLoaded] = useState(false)
  const [serverRes, setServerRes] = useState({ count: 1, entryId: 'abc123' })
  const customUrl = usePortalyLink('waiting-list', `?id=${serverRes.entryId}`)
  // const { hasCopied, onCopy } = useClipboard(customUrl)
  // useEffect(() => {
  //   window.grecaptcha.ready(() => {
  //     setCaptchaLoaded(true)
  //   })
  // }, [])

  const { register, handleSubmit, control, formState, watch, setError } = useForm()
  const onSubmit = handleSubmit(async ({ platform, website, ...data }) => {
    if (data.email === invitationEmail) {
      setError('email', {
        type: 'manual',
        message: '不能填寫邀請人的 E-mail'
      })
      return
    }
    await new Promise(resolve => window.grecaptcha.ready(resolve))
    const token = await window.grecaptcha.execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, { action: 'submit' })
    const createWaitingList = httpsCallable(functions, 'createWaitingList')
    const res = await createWaitingList({
      ...sanitize({
        platform,
        website: `${platformPrefix[platform]?.value ?? ''}${website}`,
        ...data,
        token,
        profileId,
      }),
      source: window.sessionStorage.getItem(WAITING_LIST_SRC) ?? '',
      abText: window.sessionStorage.getItem(WAITING_LIST_AB_TEXT) ?? '',
    })
    if (window.gtag) {
      window.gtag('event', 'generate_lead')
    }
    setServerRes(res.data)
  })
  const platform = watch('platform')
  return formState.isSubmitSuccessful ? (
    <Stack py="6" spacing={8}>
      <Stack>
        <Text>已送出你的申請！請靜候通知</Text>
        {/* <Text>你的白名單等待序號為：</Text>
        <Heading color="red.500">{serverRes.count} 號</Heading> */}
         <Text>
          相關問題，請洽：service@portaly.cc
        </Text>
      </Stack>
      {/* <Stack>
        <Text>
          五月初開始，我們將依序發送帳號。現在你只要邀請 <Em>3 位朋友</Em> 加入你的白名單，即可獲得「免排隊」的優先資格！
        </Text>
        <Text>邀請連結：</Text>
        <InputGroup>
          <Input isReadOnly value={customUrl} overflowX="auto" />
          <InputRightElement width="6rem">
            <Button h='1.75rem' size='sm' onClick={onCopy}>
              {hasCopied ? '已複製' : '複製'}
            </Button>
          </InputRightElement>
        </InputGroup>
      </Stack> */}
    </Stack>
  ) : (
    <>
      <Intro name={profileName} slug={profileSlug} email={invitationEmail} />
      <script src={`https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_RECAPTCHA_SITE_KEY}`} />
      <Stack as="form" onSubmit={onSubmit} spacing={12} py="8">
        {fields.map(({ name, type, label, helper, options, when, placeholder, ...config }) => {
          const ladd = name === 'website' && platformPrefix[platform]?.label
          const render = (
            <FormField
              key={name}
              {...register(name, config)}
              type={type}
              label={label}
              helper={helper}
              options={options}
              control={control}
              errors={formState.errors}
              placeholder={ladd ? '輸入社群帳號' : (placeholder ?? '輸入你的回答')}
              leftAddon={ladd}
              {...config}
            />
          )
          return when ? <Dependent key={name} control={control} when={when}>{render}</Dependent> : render
        })}
        <Box textAlign={responsive('center', 'left')}>
          <Button
            px="8"
            type="submit"
            isLoading={formState.isSubmitting}
            colorScheme="primary"
            // isDisabled={!captchaLoaded}
          >送出</Button>
        </Box>
      </Stack>
    </>
  )
}

export default WaitingListForm
